import { screen } from '@/router/screenRoutes';

export default [
  {
    ...screen('promoter-invoices-listing'),
    component: () => import('@/views/invoices/PromoterInvoicesListing.vue'),
  },
  {
    ...screen('promoter-invoice-upload'),
    component: () => import('@/views/invoices/PromoterInvoiceUpload.vue'),
  },
  {
    ...screen('promoter-invoices-admin-listing'),
    component: () => import('@/views/invoices/admin/PromoterInvoicesAdminListing.vue'),
  },
  {
    ...screen('promoter-invoices-follow-up'),
    component: () => import('@/views/invoices/admin/PromoterInvoicesFollowUp.vue'),
  },
];
